import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import locationService from "../../services/LocationService";

export const getLocationList = createAsyncThunk(
  "location/getLocationList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await locationService.GetLocationList();
      return response.data?.ResultSet || response.data?.resultSet || [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.Message ||
        error.message ||
        "Failed to get location list"
      );
    }
  }
);

export const addLocation = createAsyncThunk(
  "location/addLocation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await locationService.AddLocation(payload);
      return response.data?.ResultSet || response.data?.resultSet || response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.Message ||
        error.message ||
        "Failed to add location"
      );
    }
  }
);

export const updateLocation = createAsyncThunk(
  "location/updateLocation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await locationService.UpdateLocation(payload);
      return response.data?.ResultSet || response.data?.resultSet || response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.Message ||
        error.message ||
        "Failed to update location"
      );
    }
  }
);

const initialState = {
  locations: [],
  loading: false,
  saving: false,
  error: null,
  success: false,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    clearLocationError: (state) => {
      state.error = null;
    },
    clearLocationSuccess: (state) => {
      state.success = false;
    },
    clearLocations: (state) => {
      state.locations = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Location List
      .addCase(getLocationList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocationList.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(getLocationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load locations";
      })

      // Add Location
      .addCase(addLocation.pending, (state) => {
        state.saving = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addLocation.fulfilled, (state) => {
        state.saving = false;
        state.success = true;
      })
      .addCase(addLocation.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || "Failed to add location";
      })

      // Update Location
      .addCase(updateLocation.pending, (state) => {
        state.saving = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateLocation.fulfilled, (state) => {
        state.saving = false;
        state.success = true;
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || "Failed to update location";
      });
  },
});

export const {
  clearLocationError,
  clearLocationSuccess,
  clearLocations,
} = locationSlice.actions;

export default locationSlice.reducer;
